import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, throwError } from 'rxjs';

import { EducationStageComponent } from '../../../components/education-stage/education-stage.component';
import { EducationService } from '../../../services/education.service';
import { FormSectionService } from '../../../services/form-section.service';

@Component({
  selector: 'bwc-add-your-education',
  templateUrl: './add-your-education.component.html',
  styleUrls: ['./add-your-education.component.scss'],
})
export class AddYourEducationComponent implements OnInit, OnDestroy {
  // REMOVED FROM FLOW
  @Input() formGroup: FormGroup;
  @Input() prevBut: boolean;
  @Input() closeBut: boolean;
  @Input() editing: boolean;
  @Input() saveToDB: boolean;
  @Input() previousStep: number;
  @Input() currentStep: number;
  @Input() steps: number;
  @ViewChild(EducationStageComponent) educationStageComponent: EducationStageComponent;
  @Output() dataStep = new EventEmitter();
  @Output() emitClose = new EventEmitter();
  @Output() emitEducation = new EventEmitter();

  form: FormGroup<FormSections>;

  countriesOptions = [];
  maxEducationSteps = 5;
  formValid = false;
  dataLoaded = false;
  dataLoaded2 = false;
  selectedLang: string;
  subSink: Subscription[] = [];

  constructor(
    private educationService: EducationService,
    private fb: FormBuilder,
    private formSection: FormSectionService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    // this.educationService.getCategories().subscribe((data) => {
    //   console.log({ data });
    // });
    this.selectedLang = this.translateService.getDefaultLang();
    this.subSink.push(
      this.translateService.onLangChange.subscribe((langChangeEvent) => {
        this.getCountriesData(langChangeEvent.lang);
      })
    );

    if (this.formGroup !== undefined) {
      this.form = this.createFormGroup();
      this.processEducationData(this.formGroup.value.education);
      setTimeout(() => this.form.updateValueAndValidity(), 0);
    } else {
      this.form = this.createFormGroup();
      this.getUserData();
      setTimeout(() => this.form.updateValueAndValidity(), 0);
    }
    this.getCountriesData(this.selectedLang);
  }

  createFormGroup(): FormGroup<FormSections> {
    return this.fb.group<FormSections>({
      formSections: this.fb.array([]),
    });
  }

  getCountriesData(lang: string) {
    this.educationService.getCountries(lang).subscribe((data) => {
      const languages = data.data.map((item) => ({
        text: item.common_name,
        val: item.alpha2_code,
      }));
      this.countriesOptions = [...languages];
      this.dataLoaded = true;
    });
  }

  getUserData() {
    this.educationService.getEducationMy().subscribe((data) => {
      this.processEducationData(data.data);
    });
  }

  processEducationData(data) {
    if (data.length === 0) {
      this.formSections.push(
        this.formSection.createEducationFormSection({
          order: 0,
          country: '',
          school_name: '',
          education_name: '',
          education_level: null,
          start_date: '',
          end_date: '',
          is_current: false,
        })
      );
    } else {
      data.forEach((item) => {
        const endDate = item.end_date === '1970-01-01T00:00:00+00:00' ? '' : item.end_date;
        this.formSections.push(
          this.formSection.createEducationFormSection({
            id: item.id,
            order: item.order,
            country: item.country,
            school_name: item.school_name,
            education_name: item.education_name,
            education_level: item.education_level,
            start_date: item.start_date,
            end_date: endDate,
            is_current: item.is_current,
          })
        );
      });
    }
    this.dataLoaded2 = true;
  }

  onFormValidityChanged(validity: boolean) {
    this.formValid = validity;
  }

  goPrev() {
    if (!this.formValid) {
      this.dataStep.emit({ previousStep: this.currentStep, step: 4 });
    } else {
      this.sendEducationData(this.form.value.formSections, false, true);
    }
  }

  onSubmit() {
    if (this.formValid) {
      this.sendEducationData(this.form.value.formSections);
    }
  }

  onEdit() {
    if (this.saveToDB) {
      this.sendEducationData(this.form.value.formSections, true);
    } else {
      this.emitEducation.emit(this.form);
      this.emitClose.emit('education');
    }
  }

  sendEducationData(data, close?, ifBack?) {
    const educationData = data.map((item) => {
      const newItem = { ...item };

      delete newItem.id;
      delete newItem.level_options;

      if (item.start_date !== '') {
        newItem.start_date = new Date(item.start_date).toISOString();
      }
      if (item.end_date !== '') {
        newItem.end_date = new Date(item.end_date).toISOString();
      }
      return newItem;
    });

    const requestBody = { items: educationData };

    this.educationService.putEducationMy(requestBody).subscribe(
      (resp) => {
        if (ifBack) {
          this.dataStep.emit({ previousStep: this.currentStep, step: 4 });
        } else if (close) {
          this.emitClose.emit('education');
          this.emitEducation.emit(this.form);
        } else {
          this.dataStep.emit({ previousStep: this.currentStep, step: 6 });
        }
      },
      (error) => {
        if (ifBack) {
          this.dataStep.emit({ previousStep: this.currentStep, step: 4 });
        }
        throwError('EducationMy error:', error);
        console.error('EducationMy error:', error);
      }
    );
  }

  close() {
    this.emitClose.emit('education');
  }

  get formSections() {
    return this.form.get('formSections') as FormArray;
  }

  ngOnDestroy(): void {
    this.subSink.forEach((sub) => sub.unsubscribe());
  }
}

interface FormSections {
  formSections: FormArray;
}
